/* Big Gun upsell brain. One rules module for every surface.
   Rules:  snippets/bgv2-upsell-rules.liquid  (#bgv2-upsell-rules, once per page)
   Facts:  snippets/bgv2-upsell-data.liquid   ([data-bgv2-upsell-data], per surface)
   Doc:    Strategy/2026-10/cart-drawer/Upsell-Brain-Rules-2026-10-03.md

   API (window.BGV2Upsell):
     read(scopeEl)                 -> the facts JSON inside scopeEl
     offers(data, opts)            -> ordered offers, each with its reason
         opts: surface ('pdp' | 'drawer' | 'page' | 'thankyou' | ...), skip [keys],
               adds (adds from the cart this session), exclude [steps], limit,
               vehicle (Garage vehicle; default BGE.Garage.active())
     card(offer, opts)             -> card HTML (opts.skip: show the No thanks link)
     bind(cardEl, offer)           -> wires the option chips inside a rendered card
     softLink(data, opts)          -> { text, url } or null ("Pipes for your machine")
     addToCart(ids, opts)          -> /cart/add.js then the attribution attributes
         opts: src, surface, fit, sections, sections_url. Resolves with the
         /cart/update.js JSON (with sections when asked).
   Universal rules applied here, whatever the surface: never what is in the cart, never
   out of stock, never across vehicle classes, year overlap and the partial-year hedge,
   dealers get nothing, signed-in California customers get no TFI. */
(function () {
  'use strict';

  var CFG = window.BGV2 || {};
  var RULES = null;
  var EXHAUST = { full: 1, slip: 1, head: 1 };
  var TUNER = { tfi: 1, rev: 1 };
  var PARTS = { spark: 1, quiet: 1, packing: 1, hardware: 1, kit: 1, decal: 1, tip: 1, merch: 1, logo: 1 };
  var SWATCH = { Blue: '#1f5fd1', Yellow: '#f2c400', Green: '#1e9a3d' };

  function rules() {
    if (RULES) return RULES;
    var el = document.getElementById('bgv2-upsell-rules');
    try { RULES = el ? JSON.parse(el.textContent) : null; } catch (e) { RULES = null; }
    return RULES;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(tpl, t) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return t && t[k] != null ? t[k] : ''; })
      .replace(/\s{2,}/g, ' ').trim();
  }
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/g, parts.join('.')).replace(/<[^>]+>/g, '');
  }
  function has(tags, tag) { return !!tag && ('|' + (tags || '') + '|').indexOf('|' + tag + '|') >= 0; }
  function yr(tag) {
    var m = String(tag || '').trim().match(/^(\d{2}|\d{4})-(\d{2}|\d{4})$/);
    if (!m) return null;
    var f = function (y) { y = parseInt(y, 10); return y >= 100 ? y : (y <= 30 ? 2000 + y : 1900 + y); };
    return [f(m[1]), f(m[2])];
  }
  function overlap(a, b) { var ra = yr(a), rb = yr(b); return !ra || !rb || (ra[0] <= rb[1] && rb[0] <= ra[1]); }
  function covers(a, list) {
    var ra = yr(a);
    if (!ra) return true;
    var rs = list.map(yr).filter(Boolean);
    if (!rs.length) return true;
    for (var y = ra[0]; y <= ra[1]; y++) {
      if (!rs.some(function (r) { return y >= r[0] && y <= r[1]; })) return false;
    }
    return true;
  }
  function yearIn(year, list) {
    var y = parseInt(year, 10);
    if (isNaN(y)) return true;
    return list.some(function (t) { var r = yr(t); return !r || (y >= r[0] && y <= r[1]); });
  }
  function yearsText(list) {
    return list.map(yr).filter(Boolean).map(function (r) { return r[0] === r[1] ? String(r[0]) : r[0] + ' to ' + r[1]; })
      .filter(function (x, i, a) { return a.indexOf(x) === i; }).join(' and ');
  }
  // No machine to pick the box by, and the pipe's years need more than one Power Box:
  // one choice per box that wins at least one of the pipe's years under the shared rule
  // (narrowest range wins). Labels come from BGV2Tfi.wins, the helper the PDP tuner row
  // uses, so the two read the same ("2015 to 2017 and 2020 to 2023"); the fallback below
  // builds the same thing from BGV2Tfi.forYear. Years with no box are left out.
  // null when there is one choice or the rule is not loaded.
  function yearChoices(boxes, pipeY) {
    var T = window.BGV2Tfi || {};
    var pr = yr(pipeY);
    var list = null;
    if (typeof T.wins === 'function') {
      list = (pr ? T.wins(boxes, pr[0], pr[1]) : T.wins(boxes)) || [];
      list = list.map(function (w) { return { box: w.row, label: w.label }; });
    } else if (typeof T.forYear === 'function') {
      var rs = boxes.map(function (c) { return yr(c.y); }).filter(Boolean);
      if (rs.length < 2) return null;
      var lo = Math.min.apply(null, rs.map(function (r) { return r[0]; }));
      var hi = Math.max.apply(null, rs.map(function (r) { return r[1]; }));
      if (pr) { lo = Math.max(lo, pr[0]); hi = Math.min(hi, pr[1]); }
      if (hi < lo || hi - lo > 40) return null;
      var byBox = [];
      for (var y = lo; y <= hi; y++) {
        var b = T.forYear(boxes, y);
        if (!b) continue;
        var g = byBox.filter(function (x) { return x.box === b; })[0];
        if (!g) { g = { box: b, runs: [] }; byBox.push(g); }
        var last = g.runs[g.runs.length - 1];
        if (last && last[1] === y - 1) last[1] = y; else g.runs.push([y, y]);
      }
      list = byBox.map(function (g) {
        return { box: g.box, label: g.runs.map(function (r) { return r[0] === r[1] ? String(r[0]) : r[0] + ' to ' + r[1]; }).join(' and ') };
      });
    }
    return list && list.length > 1 ? list : null;
  }

  // The catalogue prefix off a title ("Parts - EXO Packing Kit" -> "EXO Packing Kit").
  // A title's trailing year range kept on one line ("(14-20)" never splits at 375, FL2-23), escaped as esc() does.
  // Only a short tail, as snippets/bgv2-nw-title.liquid: "(17\" EVO/ECO Muffler)" overran a narrow card (FL3-12).
  function nwName(t) {
    var m = / \(([^()]{1,11})\)$/.exec(t);
    return m ? esc(t.slice(0, m.index)) + ' <span class="bgv2-nw">(' + esc(m[1]) + ')</span>' : esc(t);
  }
  function plainName(t) { return String(t || '').replace(/^(Parts|Gear|Sticker)\s*-\s*/i, '').trim(); }
  function shortName(t) {
    return plainName(t).split(' - ')[0].trim();
  }
  function machineFromTitle(row) {
    var t = String(row.t || '');
    if (t.indexOf(' - ') > 0) return t.split(' - ').pop().split(' (')[0].split(' *')[0].trim();
    if (row.fit) return row.fit.replace(/^fit_/, '').split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    return '';
  }
  function garage() { return window.BGE && window.BGE.Garage && typeof window.BGE.Garage.active === 'function' ? window.BGE.Garage : null; }
  function vehicleName(v) { return v ? (window.BGE && window.BGE.formatVehicle ? window.BGE.formatVehicle(v) : [v.year, v.make, v.model].filter(Boolean).join(' ')) : ''; }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* ignore */ } }

  // Machines with no model collection (e.g. the XR 650R) have no pipe candidates in the
  // server data. enrich() fills that gap from predictive search by fit tag, then
  // /products/<handle>.js for the variant. Only runs when needed; cached per fit tag.
  var SERIES_TAGS = ['EXO Stainless', 'EXO R', 'EXO', 'EVO R', 'EVO U', 'EVO M', 'EVO S', 'ECO', 'Explorer', 'Ballistic', 'Banshee', 'Warhead'];
  var CLASS_TAGS = ['Dual-Sport', 'Dirt Bike', 'UTV', 'ATV', 'Street'];
  var TYPE_KIND = { 'Full Exhaust Systems': 'full', 'Slip On Mufflers': 'slip', 'Head Pipes': 'head' };
  var fitCache = {};
  function feed() { return window.BGE && window.BGE.fitFeed && typeof window.BGE.fitFeed.index === 'function' ? window.BGE.fitFeed : null; }
  function bestFits(data) {
    if (!feed() || !data || !data.anchors) return [];
    data.__best = data.__best || {};
    return data.anchors.filter(function (a) { return TUNER[a.k] && a.fit && !(a.fit in data.__best); })
      .map(function (a) { return a.fit; }).filter(function (f, i, l) { return l.indexOf(f) === i; }).slice(0, 2);
  }
  function needsEnrich(data) {
    if (!data || data.__enriched || !data.anchors) return [];
    var fits = [];
    data.anchors.forEach(function (a) {
      if (!a.fit || !(a.k === 'slip' || a.k === 'head' || TUNER[a.k])) return;
      var hasPipe = (data.cands || []).some(function (c) { return EXHAUST[c.k] && has(c.tags, a.fit); });
      if (!hasPipe && fits.indexOf(a.fit) < 0) fits.push(a.fit);
    });
    return fits.slice(0, 2).concat(bestFits(data).filter(function (f) { return fits.indexOf(f) < 0; }));
  }
  function rowFromProduct(pj) {
    var v = (pj.variants || []).filter(function (x) { return x.available; })[0];
    if (!v || /^parts/i.test(pj.title || '')) return null;
    var tags = pj.tags || [];
    var fit = tags.filter(function (x) { return x.indexOf('fit_') === 0; }).sort(function (a, b) { return b.length - a.length; })[0] || '';
    var y = tags.filter(function (x) { return /^(\d{2}|\d{4})-(\d{2}|\d{4})$/.test(x); })[0] || '';
    var img = pj.featured_image ? (pj.featured_image.indexOf('//') === 0 ? 'https:' + pj.featured_image : pj.featured_image) : '';
    if (img) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=128';
    return { k: TYPE_KIND[pj.type], h: pj.handle, t: pj.title, u: '/products/' + pj.handle, v: v.id, p: v.price, m: money(v.price),
      pn: v.title && v.title !== 'Default Title' ? v.title : (v.sku || ''), img: img,
      c: CLASS_TAGS.filter(function (x) { return tags.indexOf(x) >= 0; })[0] || '',
      s: SERIES_TAGS.filter(function (x) { return tags.indexOf(x) >= 0; })[0] || '',
      fit: fit, y: y, tags: tags.join('|'), a: true };
  }
  function fetchFit(fit) {
    if (fitCache[fit]) return fitCache[fit];
    var url = '/search/suggest.json?q=' + encodeURIComponent(fit) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=tag';
    fitCache[fit] = fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var ps = ((j && j.resources && j.resources.results && j.resources.results.products) || []).filter(function (p) {
        return p.available && (p.tags || []).indexOf(fit) >= 0 && TYPE_KIND[p.type];
      }).slice(0, 6);
      return Promise.all(ps.map(function (p) {
        return fetch('/products/' + p.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pj) { return pj ? rowFromProduct(pj) : null; }).catch(function () { return null; });
      }));
    }).then(function (rows) { return (rows || []).filter(Boolean); }).catch(function () { return []; });
    return fitCache[fit];
  }
  // The known-fit feed's best-sellers tag view is sorted Best selling, so its first
  // in-stock exhaust row is that machine's best-selling pipe.
  function fetchBest(data) {
    var fits = bestFits(data);
    if (!fits.length) return Promise.resolve();
    return Promise.all(fits.map(function (fit) {
      return feed().index('/collections/best-sellers/' + fit).then(function (rows) {
        var r = (rows || []).filter(function (x) { return x[4] !== false && /Full Exhaust Systems|Slip On Mufflers/.test(x[3]); })[0];
        data.__best[fit] = r ? r[1] : null;
      }).catch(function () { data.__best[fit] = null; });
    }));
  }
  function enrich(data) {
    var fits = needsEnrich(data);
    if (!fits.length) { if (data) data.__enriched = true; return Promise.resolve(data); }
    var pipeFits = fits.filter(function (f) { return !(data.cands || []).some(function (c) { return EXHAUST[c.k] && has(c.tags, f); }); });
    return Promise.all(pipeFits.map(fetchFit).concat([fetchBest(data)])).then(function (lists) {
      lists = lists.slice(0, pipeFits.length).filter(Array.isArray);
      lists.forEach(function (rows) { rows.forEach(function (r) { if (!data.cands.some(function (c) { return c.h === r.h; })) data.cands.push(r); }); });
      data.__enriched = true;
      return data;
    });
  }

  function read(scope) {
    var el = (scope || document).querySelector('[data-bgv2-upsell-data]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  // The item the offers are for: the PDP product, or the lead line of the cart
  // (an exhaust beats a tuner beats a part; within each, the newest line first).
  function pickAnchor(data, surface) {
    var a = data.anchors || [];
    if (surface === 'pdp' || surface === 'product') return a[0] || null;
    var first = function (fn) { for (var i = 0; i < a.length; i++) if (fn(a[i])) return a[i]; return null; };
    return first(function (x) { return EXHAUST[x.k] && x.fit; }) || first(function (x) { return EXHAUST[x.k]; }) ||
      first(function (x) { return TUNER[x.k]; }) || first(function (x) { return PARTS[x.k]; }) || null;
  }

  function offers(data, opts) {
    var R = rules();
    opts = opts || {};
    if (!R || !data || !data.ctx || data.ctx.dealer) return [];
    var surface = opts.surface || data.ctx.surface || 'pdp';
    var anchor = pickAnchor(data, surface);
    if (!anchor) return [];
    var copy = R.copy || {};
    var H = R.handles || {};
    var cart = data.cart || [];
    var g = garage();
    var vehicle = opts.vehicle !== undefined ? opts.vehicle : (g ? g.active() : null);
    var fitsFn = opts.fits || (g ? function (tags) { return g.fits(tags); } : null);
    var vFits = !!(vehicle && fitsFn && anchor.tags && anchor.tags.indexOf('fit_') >= 0 && fitsFn(anchor.tags) === 'fits');
    var machine = vFits ? vehicleName(vehicle) : machineFromTitle(anchor);
    var inCart = {};
    cart.forEach(function (c) { inCart['h:' + c.h] = 1; inCart['v:' + c.v] = 1; });
    if (surface === 'pdp') inCart['h:' + anchor.h] = 1;
    var cands = (data.cands || []).filter(function (c) { return c.a && !inCart['h:' + c.h] && !inCart['v:' + c.v]; });
    var byHandle = function (h) { for (var i = 0; i < cands.length; i++) if (cands[i].h === h) return cands[i]; return null; };
    var sameClass = function (c) { return !anchor.c || !c.c || c.c === anchor.c; };
    var cartHas = function (fn) { return cart.some(fn); };
    var drawerish = surface === 'drawer' || surface === 'page';
    var exhaustInCart = cart.filter(function (c) { return EXHAUST[c.k]; })[0] || null;
    var seriesHint = anchor.s || (exhaustInCart && exhaustInCart.s) || '';
    var F = R.flags || {};
    // Packing kit for a muffler: the bg_pack tag when Kyle's map lands, else the series
    // rule (EXO family only). Never a default size: a wrong kit is a return.
    function packFor(row) {
      if (!row) return null;
      var byTag = H.packing_by_tag || {};
      for (var tag in byTag) {
        if (has(row.tags, tag)) return byTag[tag] ? { h: byTag[tag], q: 1 } : null;
      }
      if ((H.no_packing_series || []).indexOf(row.s) >= 0) return null;
      var h = (H.packing_by_series || {})[row.s];
      if (!h) return null;
      return { h: h, q: /dual/i.test(row.t || '') ? 2 : 1 };
    }
    var cartLine = function (h) { for (var i = 0; i < cart.length; i++) if (cart[i].h === h) return cart[i]; return null; };

    var steps = (R.ladders && R.ladders[anchor.k]) ? R.ladders[anchor.k].slice() : [];
    if (drawerish) (R.drawer_tail || []).forEach(function (s) { if (steps.indexOf(s) < 0) steps.push(s); });
    var exclude = opts.exclude || [];
    var out = [];

    function offer(step, o) {
      o.step = step;
      o.key = o.key || (step + ':' + (anchor.fit || anchor.h));
      o.anchor = anchor.h;
      o.machine = machine;
      return o;
    }

    function gainFor(p) {
      if (!drawerish || data.ctx.total >= data.ctx.threshold) return '';
      return (data.ctx.total + p.p >= data.ctx.threshold) ? copy.ship_unlock : fill(copy.ship_gain, { amount: p.m || money(p.p) });
    }

    // A pipe part for "the same machine": its years cover every year of the item, or the
    // Garage machine's year sits inside them. A one-year overlap is not the same machine.
    function sameMachine(c) {
      if (!has(c.tags, anchor.fit) || !sameClass(c)) return false;
      if (vFits && vehicle.year) return yearIn(vehicle.year, [c.y || '']);
      return covers(anchor.y, [c.y]);
    }

    var builders = {
      tuner: function () {
        if (!EXHAUST[anchor.k] || !anchor.fit) return null;
        if (cartHas(function (c) { return TUNER[c.k] && has(c.tags, anchor.fit); })) return null;
        var kinds = (R.tuner_first_for || []).indexOf(anchor.c) >= 0 ? ['rev', 'tfi'] : ['tfi', 'rev'];
        // Every Power Box and Rev Box for this pipe, in class order, under one year rule (FL1-02: the PDP tuner row's
        // picker). A Rev Box is never offered for a year it does not cover, the same as a Power Box.
        // Sold-out boxes come too (a: false, FL1-20): the year rule sees the box that really wins a year, and a year a
        // sold-out box wins gets no offer, never another box. Only in-stock boxes are ever offered.
        var tuners = (data.cands || []).filter(function (c) { return TUNER[c.k] && !inCart['h:' + c.h] && !inCart['v:' + c.v]; });
        var m = [];
        kinds.forEach(function (kind) {
          if (kind === 'tfi' && data.ctx.ca) return;
          tuners.forEach(function (c) { if (c.k === kind && has(c.tags, anchor.fit) && overlap(anchor.y, c.y) && sameClass(c)) m.push(c); });
        });
        if (!m.some(function (c) { return c.a; })) return null;
        var T = window.BGV2Tfi || {};
        var forYear = T.forYear || function (rows, y) { return rows.filter(function (c) { return c.y && yearIn(y, [c.y]); })[0] || null; };
        // The year: a saved machine that fits this pipe (tuneYear: any saved machine, none when fitting machines
        // pick different boxes or none fits). A vehicle passed in (tests) is used as it is.
        var year = null;
        if (opts.vehicle !== undefined || !g || typeof T.tuneYear !== 'function') year = (vFits && vehicle && vehicle.year) ? vehicle.year : null;
        else year = T.tuneYear(g, anchor.tags || '', m).year;
        var mspan = machine || 'machine';
        var unreadable = m.length > 1 && m.some(function (c) { return !yr(c.y); });
        var pick = null;
        if (year) {
          pick = forYear(m, year);
          if (!pick || !pick.a) return null; // no box covers the rider's year, or it is sold out: the PDP says so
        } else {
          // Boxes listed only by title (their years cannot be read): the PDP lists them; no one-tap add here.
          if (unreadable) return null;
          var choices = yearChoices(m, anchor.y);
          if (choices) choices = choices.filter(function (c) { return c.box.a; }); // a sold-out year is not offered
          if (choices && !choices.length) return null;
          if (choices) {
            if (!drawerish) return null; // several boxes and no year: only the cart offers the year choice
            var allRev = choices.every(function (c) { return c.box.k === 'rev'; });
            // Rev Boxes and Power Boxes in one year list: the neutral line (call 81), its call-us tail when years are missing.
            var mixed = !allRev && choices.some(function (c) { return c.box.k === 'rev'; });
            var cov = covers(anchor.y, m.map(function (c) { return c.y; }).filter(Boolean));
            var mixedLine = copy.tuner_mixed_line || 'Pick the tune for your year.';
            if (mixed && !cov) { var mt = String(copy.tuner_line_partial_multi || '').split('Call us')[1]; if (mt) mixedLine += ' Call us' + mt; }
            return offer('tuner', { kind: allRev ? 'rev' : 'tfi', src: allRev ? 'rev' : 'tfi', state: 'years', fit: anchor.fit, years: m.map(function (c) { return c.y; }).filter(Boolean),
              eyebrow: '', heading: allRev ? copy.rev_h : (copy.tuner_h_drawer || fill(copy.tuner_h, { machine: mspan })),
              line: allRev ? copy.rev_line : (mixed ? fill(mixedLine, {}) : (cov ? fill(copy.tuner_line, { machine: mspan }) : fill(copy.tuner_line_partial_multi || copy.tuner_line_partial, { machine: mspan }))),
              items: [choices[0].box], choices: choices, btn: allRev ? copy.rev_add : copy.tuner_add, skipLabel: copy.tuner_skip || copy.no_thanks, fine: allRev ? '' : copy.tuner_ca });
          }
          var wins = typeof T.wins === 'function' ? T.wins(m, (yr(anchor.y) || [])[0], (yr(anchor.y) || [])[1]) : [];
          pick = (wins[0] && wins[0].row) || m[0];
          if (!pick.a) return null;
        }
        var kind = pick.k === 'rev' ? 'rev' : 'tfi';
        var ys = m.filter(function (c) { return c.k === kind; }).map(function (c) { return c.y; }).filter(Boolean);
        var state = year ? (kind === 'rev' ? 'rev' : 'full') : (kind === 'rev' ? 'rev' : (covers(anchor.y, ys) ? 'full' : 'partial'));
        var years = yearsText(ys);
        // Call 76 (FL2-06): no year to check and one box for part of the pipe's years: the eyebrow and heading name
        // the years it shares with the pipe (the one winner's label), and the add is a self-attest naming them
        // ("Mine is a 2006. Add Rev Box"), never a bare add. A rider's year outside them gets no offer (above).
        var olap = (!year && wins && wins.length === 1 && wins[0].label) ? wins[0].label : years;
        // One year: "Mine is a 2006."; a range: "Mine is a 2012 to 2013 model." (call 80).
        var attest = function (add) { return fill(/^\d{4}$/.test(String(olap)) ? (copy.tuner_attest || 'Mine is a {years}. {add}') : (copy.tuner_attest_range || 'Mine is a {years} model. {add}'), { years: olap, add: add }); };
        if (kind === 'rev') {
          // A Rev Box that covers only part of the pipe's years, no year to check: the partial eyebrow, as the PDP.
          var revPartial = !year && !covers(anchor.y, ys);
          return offer('tuner', { kind: 'rev', src: 'rev', state: 'rev', quiet: true, fit: anchor.fit,
            eyebrow: revPartial ? fill(copy.tuner_eyebrow_partial, { years: olap }) : ((vFits && !drawerish) ? fill(copy.fits, { machine: machine }) : copy.tuner_eyebrow),
            // The shared years read neutral with no machine (call 82): no warning look, only the years.
            eyebrowIcon: revPartial ? 'years' : ((vFits && !drawerish) ? 'ok' : ''),
            heading: copy.rev_h, line: copy.rev_line, items: [pick], btn: revPartial ? attest(copy.rev_add) : copy.rev_add, skipLabel: copy.no_thanks });
        }
        if (state === 'partial') {
          return offer('tuner', { kind: 'tfi', src: 'tfi', state: 'partial', quiet: true, fit: anchor.fit, years: ys,
            eyebrow: fill(copy.tuner_eyebrow_partial, { years: olap }), eyebrowIcon: 'years',
            heading: fill(copy.tuner_h_partial, { years: olap, machine: mspan }), line: fill(copy.tuner_line_partial, { machine: mspan }),
            items: [pick], btn: attest(copy.tuner_add), skipLabel: copy.tuner_skip_partial || copy.no_thanks, fine: copy.tuner_ca });
        }
        // In the cart with no fitting machine the machine line already names the machine above the
        // card, so the card drops its eyebrow and the add stays above the pinned footer at 390.
        var pair = (surface !== 'pdp' && anchor.p) ? { label: copy.tuner_pair, money: money(anchor.p + pick.p) } : null;
        return offer('tuner', { kind: 'tfi', src: 'tfi', state: 'full', fit: anchor.fit, years: ys,
          eyebrow: (vFits && !drawerish) ? fill(copy.fits, { machine: machine }) : (drawerish && !vFits ? '' : copy.tuner_eyebrow), eyebrowIcon: (vFits && !drawerish) ? 'ok' : '',
          heading: (drawerish && copy.tuner_h_drawer) ? copy.tuner_h_drawer : fill(copy.tuner_h, { machine: mspan }), line: fill(copy.tuner_line, { machine: mspan }),
          items: [pick], pair: pair, btn: copy.tuner_add, skipLabel: copy.tuner_skip || copy.no_thanks, fine: copy.tuner_ca });
      },
      headpipe: function () {
        if (anchor.k !== 'slip' || !anchor.fit) return null;
        if (cartHas(function (c) { return c.k === 'head' && has(c.tags, anchor.fit); })) return null;
        var m = cands.filter(function (c) { return c.k === 'head' && c.s === anchor.s && sameMachine(c); });
        if (!m.length) return null;
        return offer('headpipe', { kind: 'headpipe', src: 'headpipe', eyebrow: copy.headpipe_eyebrow, heading: fill(copy.headpipe_h, { series: anchor.s }),
          line: copy.headpipe_line, items: [m[0]], btn: copy.headpipe_add, skipLabel: copy.no_thanks });
      },
      slipon: function () {
        if (anchor.k !== 'head' || !anchor.fit) return null;
        if (cartHas(function (c) { return c.k === 'slip' && has(c.tags, anchor.fit); })) return null;
        var m = cands.filter(function (c) { return c.k === 'slip' && c.s === anchor.s && sameMachine(c); });
        if (!m.length) return null;
        return offer('slipon', { kind: 'slipon', src: 'slipon', eyebrow: copy.slipon_eyebrow, heading: fill(copy.slipon_h, { series: anchor.s }),
          line: copy.slipon_line, items: [m[0]], btn: copy.slipon_add, skipLabel: copy.no_thanks });
      },
      kit: function () {
        // Decal and tip kits dress a Big Gun pipe: after a tuner, only when the cart holds one (CD-19).
        if (TUNER[anchor.k] && !exhaustInCart) return null;
        var series = EXHAUST[anchor.k] ? anchor.s : (TUNER[anchor.k] ? seriesHint : '');
        var list = R.kit_series || [];
        if (EXHAUST[anchor.k] && list.indexOf(series) < 0) return null;
        if (series && list.indexOf(series) < 0) series = '';
        if (cartHas(function (c) { return has(c.tags, 'Decals') && (!series || c.s === series); })) return null;
        var rows = cands.filter(function (c) { return c.k === 'kit' && (series ? c.s === series : list.indexOf(c.s) >= 0); });
        if (!rows.length) return null;
        var colour = R.default_colour || 'Blue';
        var mk = R.make_colours || {};
        var tagSrc = anchor.tags || (exhaustInCart && exhaustInCart.tags) || '';
        Object.keys(mk).forEach(function (make) { if (has(tagSrc, make)) colour = mk[make]; });
        // A saved machine's make colour only when it fits this pipe; otherwise the pipe's own make (FL3-21 KIT-COLOUR).
        if (vFits && mk[vehicle.make]) colour = mk[vehicle.make];
        return offer('kit', { kind: 'kit', src: 'kit', quiet: true, key: 'kit:' + (series || 'any'),
          eyebrow: series ? fill(copy.kit_eyebrow, { series: series }) : copy.kit_eyebrow_any, heading: copy.kit_h,
          line: series ? fill(copy.kit_line, { series: series }) : copy.kit_line_any,
          kit: { rows: rows, sel: { s: series, c: colour, tip: 'turn', st: 'decal' }, fixed: !!series },
          items: [], btn: copy.kit_add, skipLabel: copy.no_thanks });
      },
      fresh: function () {
        if (!EXHAUST[anchor.k] || anchor.k === 'head' || F.fresh_on === false) return null;
        if (typeof window.BGV2_FRESH === 'function') {
          var hooked = window.BGV2_FRESH({ anchor: anchor, cands: cands, cart: cart, rules: R });
          return hooked ? offer('fresh', hooked) : null;
        }
        if (cartHas(function (c) { return c.k === 'packing'; })) return null;
        var pk = packFor(anchor);
        var pack = pk && byHandle(pk.h);
        if (!pack) return null;
        var item = Object.assign({}, pack, { q: pk.q });
        return offer('fresh', { kind: 'fresh', src: 'fresh', quiet: true, key: 'fresh:' + anchor.s, eyebrow: copy.fresh_eyebrow,
          heading: copy.fresh_h, line: copy.fresh_line, items: [item], btn: fill(copy.fresh_btn, { part: shortName(pack.t) }), skipLabel: copy.no_thanks });
      },
      install: function () {
        if (anchor.k !== 'quiet') return null;
        if (cartHas(function (c) { return c.k === 'spark'; })) return null;
        var spark = byHandle(H.spark);
        if (!spark) return null;
        var ring = byHandle(H.ring);
        return offer('install', { kind: 'pair', src: 'pair', key: 'install:' + spark.h, eyebrow: copy.install_eyebrow, heading: copy.install_h,
          line: copy.install_line, items: [spark], extra: gainFor(spark), btn: copy.install_btn, skipLabel: copy.no_thanks,
          alt: ring ? { label: fill(copy.ring_link, { price: ring.m || money(ring.p) }), ids: String(ring.v), src: 'ring' } : null });
      },
      dura: function () {
        if (!drawerish || F.dura_on === false || anchor.k !== 'packing') return null;
        var to = (H.dura_for || {})[anchor.h];
        var line = cartLine(anchor.h);
        if (!to || !line) return null;
        if (cartHas(function (c) { return c.h === to; })) return null;
        var dura = byHandle(to);
        if (!dura) return null;
        var q = line.q || 1;
        var diff = (dura.p - (line.p || anchor.p || 0)) * q;
        if (diff <= 0) return null;
        return offer('dura', { kind: 'dura', src: 'dura', key: 'dura:' + anchor.h, eyebrow: copy.dura_eyebrow, heading: copy.dura_h,
          line: copy.dura_line, items: [Object.assign({}, dura, { q: q })], btn: fill(copy.dura_btn, { diff: money(diff) }),
          swap: { key: line.key, q: q, restore: line.v }, skipLabel: copy.no_thanks });
      },
      screws: function () {
        if (F.screws_on !== true || anchor.k !== 'packing') return null;
        var h = (H.screws_by_series || {})[seriesHint];
        var s = h && byHandle(h);
        if (!s || cartHas(function (c) { return c.h === s.h; })) return null;
        return offer('screws', { kind: 'pair', src: 'pair', key: 'screws:' + s.h, eyebrow: copy.screws_eyebrow, heading: copy.screws_h,
          line: copy.screws_line, items: [s], extra: gainFor(s), btn: copy.add, skipLabel: copy.no_thanks });
      },
      pipe: function () {
        if (!TUNER[anchor.k] || !anchor.fit) return null;
        if (cartHas(function (c) { return EXHAUST[c.k]; })) return null;
        var pipes = cands.filter(function (c) { return EXHAUST[c.k] && c.k !== 'head' && has(c.tags, anchor.fit) && sameClass(c) && overlap(anchor.y, c.y); });
        if (vehicle && vehicle.year) {
          var yrOk = pipes.filter(function (c) { return !c.y || yearIn(vehicle.year, [c.y]); });
          if (yrOk.length) pipes = yrOk;
        }
        if (!pipes.length) return null;
        var pick = null;
        // "Most popular" has one source (FL1-34): the series the TFI PDP's pipe list badges (bgv2-badge.liquid from
        // Theme settings; ATV slip-ons and full systems separately, the other classes one series, Youth never). A
        // badged pipe leads, slip-on first, and only then may the card say riders pick it.
        var isPopular = function (c) {
          var cls = c.c || anchor.c, pop = (CFG.popular && CFG.popular[cls]) || {};
          if (!c.s || c.s === CFG.youthSeries) return false;
          return cls === 'ATV' ? c.s === (c.k === 'full' ? pop.full : pop.slip) : !!pop.slip && c.s === pop.slip;
        };
        var plainFirst = function (c) { return /dual|black|edition|\*/i.test(c.t) ? 1 : 0; };
        var popular = pipes.filter(isPopular).sort(function (x, y) { return (x.k === 'slip' ? 0 : 1) - (y.k === 'slip' ? 0 : 1) || plainFirst(x) - plainFirst(y) || x.p - y.p; });
        if (popular.length) pick = popular[0];
        var fh = pick ? null : (data.__best && data.__best[anchor.fit]) || (window.BGE && typeof window.BGE.fitFeedBest === 'function' ? window.BGE.fitFeedBest(anchor.fit) : null);
        if (fh) pick = pipes.filter(function (c) { return c.h === fh; })[0] || null;
        // Slip-on + tuner is the commonest pair (895 orders vs 558 for full systems), so a
        // slip-on in the class's popular series leads; plain finishes before Dual, Black
        // or edition variants; then the lower price.
        var pop = (CFG.popular && CFG.popular[anchor.c]) || {};
        var plain = function (c) { return /dual|black|edition|\*/i.test(c.t) ? 1 : 0; };
        var tiers = [['slip', pop.slip], ['slip', pop.full], ['full', pop.full], ['slip', ''], ['full', '']];
        for (var ti = 0; ti < tiers.length && !pick; ti++) {
          var tk = tiers[ti][0], ts = tiers[ti][1];
          if (ts === undefined) continue;
          var m = pipes.filter(function (c) { return c.k === tk && (!ts || c.s === ts); })
            .sort(function (x, y) { return plain(x) - plain(y) || x.p - y.p; });
          pick = m[0] || null;
        }
        if (!pick) return null;
        // "See every pipe" goes to the model collection only when it exists (DA-04: 93 tuners have none,
        // /collections/polaris-rzr-200-exhaust was a 404). BGE.modelUrl checks bge-model-collections.json;
        // any split of the fit slug into make and model rebuilds the same handle. Otherwise a product search.
        var slug = anchor.fit.replace(/^fit_/, '');
        var cut = slug.indexOf('-');
        var real = cut > 0 && window.BGE && typeof window.BGE.modelUrl === 'function' ? window.BGE.modelUrl({ make: slug.slice(0, cut), model: slug.slice(cut + 1) }) : null;
        var allUrl = real || '/search?q=' + encodeURIComponent(slug.replace(/-/g, ' ')) + '&type=product';
        // The "riders pick" sentence only for a pipe the list badges Most popular; otherwise its first sentence alone.
        var pipeLine = isPopular(pick) ? copy.pipe_line : String(copy.pipe_line || '').split('. ')[0].replace(/\.?$/, '.');
        // "your" only when a saved machine fits this box (FL1-42, FL3-21 TFI-YOUR): "Add the pipe for the Yamaha Raptor 700".
        var theM = function (t) { return vFits ? t : String(t || '').replace(/\byour \{machine\}/, 'the {machine}'); };
        return offer('pipe', { kind: 'pipe', src: 'pipe', eyebrow: copy.pipe_eyebrow, heading: fill(theM(copy.pipe_h), { machine: machine }),
          line: pipeLine, items: [pick], btn: copy.add, skipLabel: copy.no_thanks,
          link: { text: fill(theM(copy.pipe_all), { machine: machine }), url: allUrl } });
      },
      merch: function () {
        var m = byHandle(H.merch);
        if (!m) return null;
        return offer('merch', { kind: 'merch', src: 'merch', quiet: true, compact: true, key: 'merch',
          eyebrow: copy.merch_eyebrow, heading: '', line: '', items: [Object.assign({}, m, { pn: '' })], variants: m.vs || null, btn: copy.add, skipLabel: copy.no_thanks,
          needAdds: drawerish ? (R.merch_after_adds || 0) : 0 });
      }
    };

    function pairBuilder(kind) {
      return function () {
        var p = null;
        if (kind === 'quiet') p = byHandle(H.quiet);
        else if (kind === 'spark') p = byHandle(H.spark);
        else if (kind === 'packing') { var pk = packFor(exhaustInCart || { s: seriesHint, tags: '', t: '' }); p = pk ? byHandle(pk.h) : null; }
        else if (kind === 'hardware') p = byHandle(H.hardware);
        else if (kind === 'logo') p = byHandle(H.logo);
        else if (kind === 'tip') { if (anchor.k === 'kit') return null; p = byHandle((H.tip_by_series || {})[anchor.s]); }
        else if (kind === 'decal') p = cands.filter(function (c) { return c.k === 'decal' && anchor.s && c.s === anchor.s; })[0] || null;
        if (!p) return null;
        if (cartHas(function (c) { return c.k === kind && kind !== 'decal' && kind !== 'tip'; })) return null;
        var pairKey = anchor.k + '>' + kind;
        var share = (R.pairs || {})[pairKey] || '';
        var part = shortName(anchor.t), partner = shortName(p.t);
        var pc = (copy.pair_copy || {})[pairKey] || {};
        return offer('pair:' + kind, { kind: 'pair', src: 'pair', key: 'pair:' + p.h, eyebrow: pc.eyebrow || copy.pair_eyebrow,
          heading: pc.h || fill(copy.pair_h, { partner: partner }),
          line: pc.line || (share ? fill(copy.pair_line, { share: share, part: part, partner: partner }) : ''),
          items: [p], extra: gainFor(p), btn: copy.add, skipLabel: copy.no_thanks });
      };
    }

    steps.forEach(function (step) {
      if (exclude.indexOf(step) >= 0) return;
      var b = builders[step] || (step.indexOf('pair:') === 0 ? pairBuilder(step.slice(5)) : null);
      if (!b) return;
      var o = b();
      if (!o) return;
      if (out.some(function (x) { return x.key === o.key; })) return;
      out.push(o);
    });
    var skip = opts.skip || [];
    out = out.filter(function (o) {
      if (skip.indexOf(o.key) >= 0) return false;
      if (o.fit && (o.kind === 'tfi' || o.kind === 'rev') && (opts.skipFits || []).indexOf(o.fit) >= 0) return false;
      if (o.needAdds && (opts.adds || 0) < o.needAdds) return false;
      return true;
    });
    if (opts.limit) out = out.slice(0, opts.limit);
    return out;
  }

  // "Pipes for your [machine]": a link, not a card, for a part when the machine is
  // known and the cart holds no Big Gun pipe for it.
  function softLink(data, opts) {
    var R = rules();
    opts = opts || {};
    if (!R || !data || !data.ctx || data.ctx.dealer) return null;
    var anchor = pickAnchor(data, opts.surface || data.ctx.surface);
    if (!anchor || !PARTS[anchor.k]) return null;
    var g = garage(), v = g ? g.active() : null;
    if (!v) return null;
    if ((data.cart || []).some(function (c) { return EXHAUST[c.k]; })) return null;
    var url = window.BGE && typeof window.BGE.browseUrl === 'function' ? window.BGE.browseUrl(v) : '';
    if (!url) return null;
    return { text: fill((R.copy || {}).soft_link, { machine: vehicleName(v) }), url: url };
  }

  // ------------------------------------------------------------------ rendering
  var ICO = {
    ok: '<svg class="bgv2-ico" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M8.3 14.2 4.1 10l1.5-1.5 2.7 2.7 6-6L15.8 6.7z"/></svg>',
    warn: '<svg class="bgv2-ico" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 2 1 18h18L10 2zm-1 6h2v5H9V8zm0 6h2v2H9v-2z"/></svg>'
  };
  var uid = 0;
  function itemHtml(it, compact, extra) {
    var copy = (rules() || {}).copy || {};
    var size = compact ? 56 : 64;
    var img = it.img ? '<a class="bgv2-up__imgl" href="' + esc(it.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(it.img) + '" width="' + size + '" height="' + size + '" alt="" loading="lazy"></a>' : '';
    var sub = [it.pn ? (copy.part || 'Part #') + ' ' + it.pn : '', extra || ''].filter(Boolean).join('. ');
    return '<div class="bgv2-up__item' + (compact ? ' is-compact' : '') + '">' + img +
      '<a class="bgv2-up__t" href="' + esc(it.u) + '">' + nwName(plainName(it.t)) + (sub ? '<span class="bgv2-up__s">' + esc(sub) + '</span>' : '') + '</a>' +
      '<span class="bgv2-up__p">' + esc(it.m || money(it.p)) + '</span></div>';
  }
  function card(o, opts) {
    opts = opts || {};
    var R = rules() || {}, copy = R.copy || {};
    var id = 'bgv2-up-' + (++uid);
    var total = o.items.reduce(function (s, it) { return s + (it.p || 0) * (it.q || 1); }, 0);
    var ids = o.items.map(function (it) { return it.v + (it.q > 1 ? ':' + it.q : ''); }).join(',');
    var h = '<section class="bgv2-up' + (o.quiet ? ' is-quiet' : '') + '" data-up-key="' + esc(o.key) + '" data-up-kind="' + esc(o.kind) + '" data-up-src="' + esc(o.src) + '" data-state="' + esc(o.state || '') + '" data-fit="' + esc(o.fit || '') + '" aria-labelledby="' + id + '">';
    if (o.eyebrow) h += '<p class="bgv2-up__eyebrow' + (o.eyebrowIcon ? ' is-' + o.eyebrowIcon : '') + '"' + (o.heading ? '' : ' id="' + id + '"') + '>' + (o.eyebrowIcon ? (ICO[o.eyebrowIcon] || '') : '') + '<span>' + esc(o.eyebrow) + '</span></p>';
    if (o.heading) h += '<h3 class="bgv2-up__h" id="' + id + '">' + esc(o.heading) + '</h3>';
    if (o.line) h += '<p class="bgv2-up__why">' + esc(o.line) + '</p>';
    if (o.choices) {
      var p0 = o.choices[0].box, same = o.choices.every(function (c) { return c.box.p === p0.p; });
      var pm = function (b) { return b.m || money(b.p); };
      h += '<fieldset class="bgv2-up__years"><legend><span>' + esc(copy.tuner_year_q) + '</span>' + (same ? '<span class="bgv2-up__years-p">' + esc(fill(copy.tuner_year_price, { price: pm(p0) })) + '</span>' : '') + '</legend><div class="bgv2-up__chips">' +
        o.choices.map(function (c, i) {
          return '<button type="button" class="bgv2-btn bgv2-btn--addon bgv2-up__yr" data-up-add="' + c.box.v + '" data-up-i="' + i + '"' + (c.box.k === 'rev' ? ' data-up-src="rev"' : '') + '><span data-up-label>' + esc(c.label) + '</span>' +
            (same ? '' : ' <span class="n">' + esc(pm(c.box)) + '</span>') + '<span class="visually-hidden">, ' + esc(copy.tuner_year_add) + (same ? ', ' + esc(pm(c.box)) : '') + '</span></button>';
        }).join('') + '</div></fieldset>';
      if (copy.add_machine) h += '<p class="bgv2-up__more"><button type="button" class="bgv2-textlink" data-bge-action="open-drawer">' + esc(copy.add_machine) + '</button></p>';
    }
    else if (o.kit) h += '<div class="bgv2-up__opts" data-up-kit-opts></div><div data-up-kit-item></div>';
    else h += o.items.map(function (it, i) { return itemHtml(it, o.compact, i === o.items.length - 1 ? o.extra : ''); }).join('');
    if (o.variants && o.variants.length > 1) {
      h += '<fieldset class="bgv2-up__opt"><legend>' + esc(copy.merch_option || 'Size') + '</legend><div class="bgv2-up__chips">' +
        o.variants.map(function (v, i) { return '<button type="button" class="bgv2-up__chip" data-up-variant="' + v.v + '" data-m="' + esc(v.m) + '" aria-pressed="' + (v.v === o.items[0].v ? 'true' : 'false') + '">' + esc(v.t) + '</button>'; }).join('') + '</div></fieldset>';
    }
    if (o.pair) h += '<p class="bgv2-up__pair"><span>' + esc(o.pair.label) + '</span><b>' + esc(o.pair.money) + '</b></p>';
    var srName = (!o.kit && o.btn === copy.add && o.items.length) ? '<span class="visually-hidden">, ' + esc(o.items.map(function (it) { return shortName(it.t); }).join(' and ')) + '</span>' : '';
    if (!o.choices) h += '<button type="button" class="bgv2-btn bgv2-btn--addon bgv2-up__add' + (o.compact ? ' bgv2-btn--sm' : '') + '" data-up-add="' + esc(ids) + '"><span data-up-label>' + esc(o.btn) + '</span> <span class="n" data-up-n>' + esc(o.kit || o.swap ? '' : money(total)) + '</span>' + srName + '</button>';
    if (o.alt) h += '<div class="bgv2-up__skip"><button type="button" class="bgv2-textlink" data-up-add="' + esc(o.alt.ids) + '" data-up-src="' + esc(o.alt.src) + '">' + esc(o.alt.label) + '</button></div>';
    if (opts.skip && o.skipLabel) h += '<div class="bgv2-up__skip"><button type="button" class="bgv2-textlink" data-up-skip>' + esc(o.skipLabel) + '</button></div>';
    if (o.link) h += '<p class="bgv2-up__more"><a class="bgv2-textlink" href="' + esc(o.link.url) + '">' + esc(o.link.text) + '</a></p>';
    if (o.fine) h += '<p class="bgv2-up__fine">' + esc(o.fine) + '</p>';
    return h + '</section>';
  }

  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  // Chips always list in one order, whatever order the collection returns.
  function ordered(a, order) { return uniq(a).sort(function (x, y) { return order.indexOf(x) - order.indexOf(y); }); }
  // The decal kit card (CD-12). With a series known it opens on the matched kit (make
  // colour, Turn down, Decal) and one "Change colour or tip" button; the chips open on
  // demand. With no series yet (a tuner-only cart) the series chips show from the start.
  function drawKit(el, o) {
    var R = rules() || {}, copy = R.copy || {}, kit = o.kit, rows = kit.rows, sel = kit.sel;
    var chip = function (legend, name, opts, cur, always) {
      if (opts.length < 2 && !always) return '';
      return '<fieldset class="bgv2-up__opt"><legend>' + esc(legend) + '</legend><div class="bgv2-up__chips">' + opts.map(function (x) {
        var sw = name === 'c' ? '<span class="bgv2-up__sw" style="background:' + (SWATCH[x.v] || '#999') + '"></span>' : '';
        return '<button type="button" class="bgv2-up__chip' + (sw ? ' is-swatch' : '') + '" data-up-kit="' + name + '" data-v="' + esc(x.v) + '" aria-pressed="' + (x.v === cur ? 'true' : 'false') + '">' + sw + '<span class="bgv2-up__chip-l">' + esc(x.l) + '</span></button>';
      }).join('') + '</div></fieldset>';
    };
    var html = '';
    if (!kit.fixed) {
      var ss = (R.kit_series || []).filter(function (s) { return rows.some(function (r) { return r.s === s; }); });
      html += chip(copy.kit_l_series, 's', ss.map(function (s) { return { v: s, l: s }; }), sel.s, true);
    }
    var row = null;
    if (sel.s) {
      var inS = rows.filter(function (r) { return r.s === sel.s; });
      var col = function (r) { return /Yellow/.test(r.tags) ? 'Yellow' : (/Green/.test(r.tags) ? 'Green' : 'Blue'); };
      var tipOf = function (r) { return /Sideways/i.test(r.t) ? 'side' : 'turn'; };
      var stOf = function (r) { return /Wrap/i.test(r.t) ? 'wrap' : 'decal'; };
      var cs = ordered(inS.map(col), ['Blue', 'Yellow', 'Green']);
      if (cs.indexOf(sel.c) < 0) sel.c = cs[0];
      html += chip(copy.kit_l_colour, 'c', cs.map(function (c) { return { v: c, l: c }; }), sel.c);
      var inC = inS.filter(function (r) { return col(r) === sel.c; });
      var tips = ordered(inC.map(tipOf), ['turn', 'side']);
      if (tips.indexOf(sel.tip) < 0) sel.tip = tips[0];
      html += chip(copy.kit_l_tip, 'tip', tips.map(function (t) { return { v: t, l: t === 'side' ? copy.kit_tip_side : copy.kit_tip_turn }; }), sel.tip);
      var inT = inC.filter(function (r) { return tipOf(r) === sel.tip; });
      var sts = ordered(inT.map(stOf), ['decal', 'wrap']);
      if (sts.indexOf(sel.st) < 0) sel.st = sts[0];
      html += chip(copy.kit_l_style, 'st', sts.map(function (t) { return { v: t, l: t === 'wrap' ? copy.kit_style_wrap : copy.kit_style_decal }; }), sel.st);
      row = inT.filter(function (r) { return stOf(r) === sel.st; })[0] || null;
    }
    var optsEl = el.querySelector('[data-up-kit-opts]');
    if (!optsEl.id) optsEl.id = 'bgv2-up-kit-' + (++uid);
    var showOpts = !!(kit.open || !row || !copy.kit_change);
    optsEl.innerHTML = showOpts ? html : '';
    optsEl.hidden = !showOpts || !html;
    var more = (!showOpts && html) ? '<p class="bgv2-up__change"><button type="button" class="bgv2-textlink" data-up-kit-more aria-expanded="false" aria-controls="' + optsEl.id + '">' + esc(copy.kit_change) + '</button></p>' : '';
    el.querySelector('[data-up-kit-item]').innerHTML = (row ? itemHtml(row, false, '') : '') + more;
    var add = el.querySelector('[data-up-add]');
    add.setAttribute('data-up-add', row ? row.v : '');
    add.disabled = !row;
    el.querySelector('[data-up-label]').textContent = row ? copy.kit_add : copy.kit_pick;
    el.querySelector('[data-up-n]').textContent = row ? (row.m || money(row.p)) : '';
    o.items = row ? [row] : [];
  }

  function bind(el, o) {
    if (!el || el.__upBound) return;
    el.__upBound = true;
    el.__offer = o;
    if (o.kit) drawKit(el, o);
    el.addEventListener('click', function (e) {
      var more = e.target.closest('[data-up-kit-more]');
      if (more && o.kit) {
        o.kit.open = true;
        drawKit(el, o);
        var first = el.querySelector('[data-up-kit][aria-pressed="true"]') || el.querySelector('[data-up-kit]');
        if (first) first.focus();
        return;
      }
      var k = e.target.closest('[data-up-kit]');
      if (k && o.kit) {
        o.kit.open = true;
        o.kit.sel[k.getAttribute('data-up-kit')] = k.getAttribute('data-v');
        drawKit(el, o);
        var again = el.querySelector('[data-up-kit="' + k.getAttribute('data-up-kit') + '"][data-v="' + k.getAttribute('data-v') + '"]');
        if (again) again.focus();
        return;
      }
      var vb = e.target.closest('[data-up-variant]');
      if (vb) {
        Array.prototype.forEach.call(el.querySelectorAll('[data-up-variant]'), function (b) { b.setAttribute('aria-pressed', b === vb ? 'true' : 'false'); });
        var add = el.querySelector('[data-up-add]');
        add.setAttribute('data-up-add', vb.getAttribute('data-up-variant'));
        var m = vb.getAttribute('data-m');
        if (m) { el.querySelector('[data-up-n]').textContent = m; var p = el.querySelector('.bgv2-up__p'); if (p) p.textContent = m; }
      }
    });
  }

  function gaItem(o) {
    var it = (o.items && o.items[0]) || {};
    return { item_id: it.pn || String(it.v || ''), item_name: it.t || '', price: (it.p || 0) / 100, quantity: 1 };
  }
  function promoView(o, surface) {
    track('view_promotion', { promotion_id: 'up_' + o.step.replace(':', '_'), creative_slot: o.state || o.kind, location_id: surface, items: [gaItem(o)] });
  }

  // ------------------------------------------------------------------ add + attribution
  function ssList(key) { try { return (sessionStorage.getItem(key) || '').split('|').filter(Boolean); } catch (e) { return []; } }
  function ssAdd(key, v) { if (!v) return; try { var l = ssList(key); if (l.indexOf(v) < 0) l.push(v); sessionStorage.setItem(key, l.join('|')); } catch (e) { /* ignore */ } }
  function jpost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .catch(function () { throw new Error('Could not add'); }) // a dropped connection, not "Failed to fetch" (CR-07)
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); });
  }
  function addToCart(ids, opts) {
    opts = opts || {};
    var list = String(ids || '').split(',').filter(Boolean).map(function (id) {
      var parts = id.split(':');
      return { id: parseInt(parts[0], 10), quantity: parseInt(parts[1] || '1', 10) || 1 };
    });
    if (!list.length) return Promise.reject(new Error('Nothing to add'));
    var entry = (opts.src || 'card') + '@' + (opts.surface || 'pdp');
    var sw = opts.swap;
    // A swap (Dura-Pak for the standard kit): drop the old line, add the new one, put the
    // old one back if the add fails.
    var step = sw ? jpost('/cart/change.js', { id: sw.key, quantity: 0 }).then(function () {
      return jpost('/cart/add.js', { items: list }).catch(function (err) {
        return jpost('/cart/add.js', { items: [{ id: parseInt(sw.restore, 10), quantity: sw.q || 1 }] }).then(function () { throw err; });
      });
    }) : jpost('/cart/add.js', { items: list });
    return step.then(function () {
      ssAdd('bgv2_cd_src', entry);
      try { sessionStorage.setItem('bgv2_cd_adds', String((parseInt(sessionStorage.getItem('bgv2_cd_adds') || '0', 10) || 0) + 1)); } catch (e) { /* ignore */ }
      var prior = String(opts.prior || '').split(',').concat(ssList('bgv2_cd_src')).filter(Boolean);
      if (prior.indexOf(entry) < 0) prior.push(entry);
      var attrs = { cart_upsell_src: prior.filter(function (x, i) { return prior.indexOf(x) === i; }).join(',') };
      if (opts.src === 'tfi') {
        attrs.tfi_src = opts.surface === 'pdp' ? 'pdp_module' : 'cart_net';
        ssAdd('bgv2_tfi_added', opts.fit);
      }
      var body = { attributes: attrs };
      if (opts.sections) { body.sections = opts.sections; body.sections_url = opts.sections_url || '/'; }
      // The items are in the cart by now: a failed attribution write must not show an error for them (CR-08).
      // No sections then, so the drawer falls back to a plain refresh.
      return jpost('/cart/update.js', body).catch(function () { return { sections: null }; });
    });
  }

  // ------------------------------------------------------------------ PDP (and any other slot)
  function goCart() {
    if (window.BGV2CD && typeof window.BGV2CD.refresh === 'function') window.BGV2CD.refresh({ open: true });
    else window.location.href = '/cart';
  }
  function initSlot(slot) {
    var data = slot.__data || read(slot);
    var target = slot.querySelector('[data-up-target]') || slot;
    if (!data) return;
    slot.__data = data;
    if (needsEnrich(data).length) { enrich(data).then(function () { initSlot(slot); }); return; }
    var surface = slot.getAttribute('data-surface') || 'pdp';
    var exclude = (slot.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    var list = offers(data, { surface: surface, exclude: exclude, limit: 1 });
    if (list.length) {
      var o = list[0];
      var soft1 = softLink(data, { surface: surface });
      target.innerHTML = card(o, { skip: false }) + (soft1 ? '<p class="bgv2-up__soft"><a class="bgv2-textlink" href="' + esc(soft1.url) + '">' + esc(soft1.text) + '</a></p>' : '');
      var el = target.querySelector('.bgv2-up');
      bind(el, o);
      slot.hidden = false;
      if (!slot.__seen || slot.__seen !== o.key) { slot.__seen = o.key; promoView(o, surface); }
      return;
    }
    var soft = softLink(data, { surface: surface });
    if (soft) {
      target.innerHTML = '<p class="bgv2-up__soft"><a class="bgv2-textlink" href="' + esc(soft.url) + '">' + esc(soft.text) + '</a></p>';
      slot.hidden = false;
    } else {
      target.innerHTML = '';
      slot.hidden = true;
    }
  }
  function initSlots() {
    var slots = Array.prototype.slice.call(document.querySelectorAll('[data-bgv2-upsell-slot]'));
    if (!slots.length) return;
    slots.forEach(initSlot);
    slots.forEach(function (slot) {
      if (slot.__clickBound) return;
      slot.__clickBound = true;
      slot.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-up-add]');
        if (!btn || btn.disabled) return;
        var el = btn.closest('.bgv2-up');
        var o = el && el.__offer;
        if (!o) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        var surface = slot.getAttribute('data-surface') || 'pdp';
        track('select_promotion', { promotion_id: 'up_' + o.step.replace(':', '_'), creative_slot: o.state || o.kind, location_id: surface, items: [gaItem(o)] });
        var altSrc = btn.getAttribute('data-up-src');
        addToCart(btn.getAttribute('data-up-add'), { src: altSrc || o.src, surface: surface, fit: o.fit }).then(function () {
          track('add_to_cart', { item_list_id: 'up_' + surface, items: [gaItem(o)] });
          btn.classList.add('is-done');
          goCart();
        }).catch(function (err) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          var lab = btn.querySelector('[data-up-label]');
          if (lab) lab.textContent = err.message;
        });
      });
    });
  }

  window.BGV2Upsell = {
    rules: rules, read: read, enrich: enrich, needsEnrich: needsEnrich, offers: offers, softLink: softLink, card: card, bind: bind,
    addToCart: addToCart, promoView: promoView, track: track, init: initSlots
  };

  function boot() {
    initSlots();
    var tries = 0;
    (function waitGarage() {
      var g = garage();
      if (g) { initSlots(); if (typeof g.onChange === 'function') g.onChange(function () { Array.prototype.forEach.call(document.querySelectorAll('[data-bgv2-upsell-slot]'), initSlot); }); return; }
      if (++tries < 25) setTimeout(waitGarage, 200);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
